import React from 'react';
import { useObservable } from 'react-use-observable';

import { Form, Input } from 'antd';

import { useFormikContext } from 'formik';
import type { FieldProps } from 'formik';
import useBoolean from 'v2/hooks/useBoolean';
import type { IAffiliateOption } from 'v2/interfaces/affiliate/selectAffiliate';
import selectAffiliateService from 'v2/services/affiliate/selectAffiliate';

import { Icon } from '@eduzz/ui-antd-theme';

import { Dialog } from './Dialog';

type IProps = FieldProps;

export const SelectAffiliate = ({ form, field }: IProps) => {
  if (!form || !field) {
    throw new Error('You must provide a Formik Provider in order to use this component');
  }

  const { setFieldValue } = useFormikContext();

  const selectedAffiliates = field?.value as IAffiliateOption[];

  useObservable(() => selectAffiliateService.loadAffiliates(), []);
  const [isLoadingAffiliates] = useObservable(() => selectAffiliateService.getIsLoading(), []);

  const [isModalOpen, setModalState] = useBoolean();

  const selectedAffiliatesQuantity = selectedAffiliates.length;
  const hasSelectAffiliates = selectedAffiliatesQuantity;

  const handleUncheckAll = () => setFieldValue(field?.name, []);

  return (
    <>
      <Form.Item label='Afiliados' layout='vertical' className='mb-0'>
        <Input
          placeholder={isLoadingAffiliates ? 'Carregando seus afiliados...' : 'Selecione seus afiliados'}
          value={hasSelectAffiliates ? `${selectedAffiliatesQuantity} Afiliado(s) ...` : ''}
          readOnly
          onClick={setModalState.toTrue}
          suffix={
            <div className='flex items-center gap-2'>
              <Icon.Search size={16} aria-hidden />
              {!!hasSelectAffiliates && (
                <button
                  type='button'
                  aria-label='Limpar afiliados selecionados'
                  onClick={event => {
                    event.stopPropagation();
                    handleUncheckAll();
                  }}
                >
                  <Icon.X size={16} />
                </button>
              )}
            </div>
          }
        />
      </Form.Item>

      <Dialog
        isOpen={isModalOpen}
        onClose={setModalState.toFalse}
        selectedQuantity={selectedAffiliatesQuantity}
        selectedAffiliates={selectedAffiliates}
        handleUncheckAll={handleUncheckAll}
      />
    </>
  );
};
